<template>
  <div class="partner">
    <div class="partner-container">
      <div class="title">
        <p>cooperative partner</p>
        <h2>合作伙伴</h2>
      </div>
      <img v-lazy='src' class="img">
    </div>
  </div>
</template>

<script>
export default {
  name: "Partner",
  data(){
    return{
      src:require('@/assets/images/img1.16.png')
    }
  }
};
</script>

<style lang="scss" scoped>
.partner {
  background-color: #f9faff;
  .partner-container{
    width: 1000px;
    margin: 0 auto;
    text-align: center;
    padding: 30px 0;
    .title {
      p {
        color: #f7a527;
        text-transform: uppercase;
        word-spacing: 10px;
        letter-spacing: 2px;
        font-size: 12px;
        line-height: 20px;
      }
      h2 {
        color: #666666;
        letter-spacing: 10px;
        margin-top: 10px;
      }
    }
    .img{padding:35px 0;width: 100%;}
  }
}
@media screen and (max-width: 768px) {
  .partner {
  background-color: #f9faff;
  .partner-container {
    width: 100%;
    padding: 30px 0px;
    .img{padding:0;width: 90%;}
  }
}
}
</style>





// WEBPACK FOOTER //
// src/components/technology/partner.vue